import { useState } from "react"
import { Button } from "../../../components/Button";
import { getUser } from "../../../services/utils";
import { useApp } from "../../../services/app-context";
import { SignedUrlImage } from "../../../components/SignedUrlImage";
import { ReactComponent as Logo } from "../../../assets/icons/animation-logo.svg";
import { useUser } from "../../../services/user-context";
const TOTAL_STEP = 2;

export const SALES_EXPERIENCE_OPTION_KEYS = {
    "JUST_STARTING_OUT": "just-starting-out",
    "1_5_YEARS": "1-5-years",
    "6_PLUS_YEARS": "6-plus-years"
}

export const SALES_EXPERIENCE_OPTIONS = {
    [SALES_EXPERIENCE_OPTION_KEYS.JUST_STARTING_OUT]: "Just starting out",
    [SALES_EXPERIENCE_OPTION_KEYS["1_5_YEARS"]]: "1 - 5 years",
    [SALES_EXPERIENCE_OPTION_KEYS["6_PLUS_YEARS"]]: "6+ years"
}

export function Step1({ onContinue }: { onContinue: () => void }) {    
    const { tenantProfile, styles } = useApp();
    const { userInfo } = useUser() as any;


    return (
        <div className="flex items-center gap-10 p-10">
            <div className="flex-[2]">
                <div className="ai-logo">
                    <div
                        className={`ai-circle`}
                        style={{
                            // increase drop shadow area when speaking
                            filter:
                                `drop-shadow(0px 0px 3.039px var(--shadow-1)) drop-shadow(0px 0px 6.077px var(--shadow-2)) drop-shadow(0px 0px 24px var(--shadow-3))`,
                            backgroundColor: "#F0ECEC",
                            // transform: `scale(${voiceIntensity + 1})`,
                            boxShadow: "0px 0px 15.216px 9.47px rgba(173, 93, 57, 0.27) inset",
                            // slow down scaling and box shadow animation
                            transition: "transform 0.01s ease, box-shadow 0.2s ease",
                        }}
                    >
                        <div className="ai-logo ">
                            {styles?.logo ? <SignedUrlImage s3Key={styles?.smallLogo} bucket={tenantProfile?.assets_bucket} alt="logo" className="w-20 h-20" /> : <Logo />}
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-col gap-4 flex-[3]">
                <div>
                    <div className="flex flex-col gap-2">
                        <span className="text-black text-[21px] font-bold ">Welcome, {userInfo?.firstName}!</span>
                        <span className="text-black text-sm font-normal">In just 2 minutes, you will unlock access to AI-powered, conversational role-play simulations, anytime, anywhere.
                            <br /><br />Ready to jump in?
                        </span>
                    </div>
                </div>
                <div className="mt-10">
                    <Button variant="primary" className="!rounded-full w-[136px] !h-[38px]" onClick={onContinue}>Get Started</Button>
                </div>
            </div>
        </div>
    )
}